import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Table } from "../../../../components/Table";
import { Api } from "../../../../services/api";
import { AddMember } from "../../../../components/AddMember";
import { TeamMember, TeamMembers } from "../../../../services/api/types/Teams";
import { AddMembersType } from "../../../../components/AddMember/addMember";
import { getColumns } from "../EditTeam/columnData";
import {
  selectMemberMap,
  useAppDispatch,
  useAppSelector,
} from "../../../../store/hooks";
import { setMembers } from "../../../../store/slices/MemberListSlice";
import { handleAxiosError } from "../../../../services/utils/handleAxiosError";
import { ColumnContainer } from "../../Admin.styles";

const testData = new Array<TeamMember>();

export const AddTeamMember = () => {
  const dispatch = useAppDispatch();
  const token = useAppSelector(state => state.auth.token);
  const [isLoading] = useState<boolean>(false);
  const [tableData, setTableData] = useState<Array<TeamMember>>(testData);

  const history = useHistory();
  const { teamId } = useParams<{ teamId: string }>();

  //pull member and teamTypes from redux
  const members = selectMemberMap();

  const fetchTeam = async () => {
    try {
      const response = await Api.teams.getTeamDetails(teamId);
      setTableData(response.data.members);
    } catch (error) {
      console.error("Teams fetch:", error);
      handleAxiosError(error);
    }
  };
  useEffect(() => {
    fetchTeam();
  }, [teamId]);

  const navigateToEdit = () => {
    const currentLocation = history.location;
    currentLocation.pathname =
      currentLocation.pathname.split("/").slice(0, -1).join("/") + "/edit";
    history.push(currentLocation);
  };

  const submitValues = (values: AddMembersType) => {
    if (!values.members) return;
    const data: TeamMembers = {
      teamId: teamId,
      members: [
        ...tableData.map(member => member.id),
        ...values.members.map(name => members.get(name as string)?.id || ""),
      ],
    };

    try {
      Api.teams.updateTeamMembers(teamId, data).then(() => {
        Api.members
          .getMembers()
          .then(res => {
            dispatch(setMembers(res.data));
          })
          .catch(() => {
            dispatch(setMembers([]));
          });
        navigateToEdit();
      });
    } catch (error) {
      console.error("Update Team Member:", error);
    }
  };

  const handleCancel = () => {
    navigateToEdit();
  };

  return (
    <ColumnContainer>
      {!isLoading ? (
        <>
          <AddMember
            header={"Add Members"}
            handleCancel={handleCancel}
            submitValues={submitValues}
          />
          <div style={{ width: "100%" }}>
            <Table
              tableType="Members"
              isLoading={isLoading}
              defaultRows={20}
              columns={getColumns(token)}
              rowsPerPage={[10, 20, 35, 50]}
              data={tableData}
            />
          </div>
        </>
      ) : null}
    </ColumnContainer>
  );
};
